/* eslint-disable */
import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
// Import store
import i18n from '@/i18n';
import store from '@/store/index';
import jwt from "jwt-decode";
import { updateLastActivity } from '@/store/modules/auth/activity'

// Holds the single in-flight bootstrap promise so concurrent navigations
// all await the same call rather than firing multiple /refresh-token requests.
let bootstrapPromise = null;

Vue.use(VueRouter);

const routes = [
  // components
  {
    path: '/redirectional',
    name: 'redirectional',
    component: () => import('../views/redirectional'),
    meta: {
      auth: false,
      permission: true,
    },
  },
  {
    path: '/components',
    name: 'components',
    component: () => import('../views/test/components'),
    meta: {
      auth: true,
      permission: true,
    },
  },
  {
    path: '/icons',
    name: 'icons',
    component: () => import('../views/test/icons'),
    meta: {
      auth: true,
      permission: true,
    },
  },
  // 404
  {
    path: '*',
    name: '404',
    component: () => import('../views/404'),
    //redirect: 'dashboard',
    meta: {
      auth: false,
      permission: true,
    },
  },
  // Login
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login'),
    meta: {
      auth: false,
      permission: true,
      title: "Login"
    },
  },
  // Dashboard
  {
    path: '/',
    redirect: to => {
      return { path: '/dashboard' }
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/dashboard'),
    meta: {
      title: 'Dashboard',
      auth: true,
      permission: 'dashboard',
      breadCrumb: [
        {
          text: 'Dashboard',
          link: '',
        },
      ],
    },
  },
  // Contacts
  {
    path: '/contacts',
    component: () => import('../views/contacts'),
    children: [
      {
        path: '/',
        name: 'contacts',
        component: () => import('../views/contacts/contacts'),
        meta: {
          title: 'Contacts',
          auth: true,
          permission: 'customer/customer',
          breadCrumb: [
            {
              text: 'Contacts',
              link: '',
            },
          ],
        },
      },
      {
        path: 'contact/:id',
        name: 'contact',
        component: () => import('../views/contacts/contact'),
        meta: {
          title: 'Contact',
          auth: true,
          permission: 'customer/customer',
          breadCrumb: [
            {
              text: 'Contacts',
              link: '/contacts',
            },
            {
              text: 'Contact#',
              param: 'id',
              link: '',
            },
          ],
        },
      },
      {
        path: 'add-new',
        name: 'Add New Customer',
        component: () => import('../views/contacts/addNew'),
        meta: {
          auth: true,
          permission: 'customer/customer',
          breadCrumb: [
            {
              text: 'Contacts',
              link: '/contacts',
            },
            {
              text: 'Add new contact',
              link: '',
            },
          ],
        },
      },
    ],
  },
  // Items
  {
    path: '/items',
    component: () => import('../views/items'),
    children: [
      // Redirect base /items to /items/products
      {
        path: '',
        redirect: '/items/products'
      },
      // Products tab
      {
        path: 'products',
        name: 'item_catalog_products',
        component: () => import('../views/items/items'),
        meta: {
          title: 'item_catalog',
          auth: true,
          permission: 'items/items',
          breadCrumb: [
            {
              text: 'Items',
              link: '',
            },
          ],
        },
      },
      // Descriptions tab
      {
        path: 'descriptions',
        name: 'item_catalog_descriptions',
        component: () => import('../views/items/items'),
        meta: {
          title: 'item_catalog',
          auth: true,
          permission: 'items/items',
          breadCrumb: [
            {
              text: 'Items',
              link: '',
            },
          ],
        },
      },
      // Add item
      {
        path: 'add-item',
        name: 'add-item',
        component: () => import('../views/items/item'),
        meta: {
          title: 'add_item',
          auth: true,
          permission: 'items/items',
        },
      },
      // Edit item
      {
        path: ':id/edit-item',
        name: 'edit-item',
        component: () => import('../views/items/item'),
        meta: {
          title: 'edit_item',
          auth: true,
          permission: 'items/items'
        },
      },
    ],
  },
  // Finance invoices
  {
    path: '/finance',
    component: () => import('../views/finance'),
    children: [
      {
        path: 'invoices',
        name: 'invoices',
        component: () => import('../views/finance/invoices.vue'),
        meta: {
          title: 'Invoices',
          auth: true,
          permission: 'finance/invoices',
          breadCrumb: [
            {
              text: 'Invoices',
              link: '',
            },
          ],
        },
      },
      {
        path: 'invoices/:id',
        name: 'invoice',
        component: () => import('../views/finance/invoice'),
        meta: {
          title: 'Invoice',
          auth: true,
          permission: 'finance/invoices',
          breadCrumb: [
            {
              text: 'Invoices',
              link: '/finance/invoices',
            },
            {
              text: 'Invoice#',
              param: 'id',
              link: '',
            },
          ],
        },
      },
    ],
  },
  // Shipments
  {
    path: '/shipments',
    component: () => import('../views/shipments'),
    children: [
      {
        path: 'book-shipment',
        name: 'book-shipment',
        component: () => import('../views/shipments/booking'),
        meta: {
          title: 'Book shipment',
          auth: true,
          permission: 'shipment/book-shipment',
        },
      },
      {
        path: 'drafts',
        name: 'drafts',
        component: () => import('../views/shipments/drafts'),
        meta: {
          title: 'drafts',
          auth: true,
          permission: 'shipment/draft',
        },
      },
      {
        path: 'unapproved-shipments',
        name: 'unapproved-shipments',
        component: () => import('../views/shipments/unapprovedShipments'),
        meta: {
          title: 'Waiting for approval',
          auth: true,
          permission: 'shipment/unapproved-shipments',
        },
      },
      {
        path: 'end-of-day',
        name: 'end-of-days',
        component: () => import('../views/shipments/endOfDays'),
        meta: {
          title: 'End of Day',
          auth: true,
          permission: 'shipment/end-of-day',
        },
      },
      {
        path: 'end-of-day/:id',
        name: 'end-of-day',
        component: () => import('../views/shipments/endOfDay'),
        meta: {
          title: 'End of Day',
          auth: true,
          permission: 'shipment/end-of-day',
        },
      },
      {
        path: 'consolidations',
        name: 'consolidations',
        component: () => import('../views/shipments/consolidations'),
        meta: {
          title: 'Consolidations',
          auth: true,
          permission: 'shipment/consolidations',
        },
      },
      {
        path: 'consolidations/:id',
        name: 'consolidation',
        component: () => import('../views/shipments/consolidation'),
        meta: {
          title: 'Consolidation',
          auth: true,
          permission: 'shipment/consolidations',
        },
      },
      {
        path: 'outbound',
        name: 'outbound-shipments',
        component: () => import('../views/shipments/outboundShipments'),
        meta: {
          title: 'outbound_shipments',
          auth: true,
          permission: 'shipment/history',
        },
      },
      {
        path: 'inbound',
        name: 'inbound-shipments',
        component: () => import('../views/shipments/inboundShipments'),
        meta: {
          title: 'inbound_shipments',
          auth: true,
          permission: 'shipment/shared',
        },
      },
      {
        path: '/view-shipment/:id',
        name: 'view-shipment',
        component: () => import('../views/shipments/viewShipment'),
        meta: {
          auth: true,
          permission: 'shipment/history',
        },
      },
    ],
  },
  // Pickups
  {
    path: '/pickups',
    component: () => import('../views/pickups'),
    children: [
      {
        path: 'booked',
        name: 'booked-pickups',
        component: () => import('../views/pickups/bookedPickups'),
        meta: {
          title: 'booked_pickup',
          auth: true,
          permission: 'pickup/booked',
        },
      },
      {
        path: 'booked/:id',
        name: 'booked-pickup',
        component: () => import('../views/pickups/viewBookedPickup'),
        meta: {
          title: 'Booked pickup',
          auth: true,
          permission: 'pickup/booked',
        },
      },
      {
        path: 'not-planned',
        name: 'not-planned-pickups',
        component: () => import('../views/pickups/notPlannedPickups'),
        meta: {
          title: 'not_planned_pickup',
          auth: true,
          permission: 'pickup/not-planned',
        },
      },
      {
        path: 'not-planned/:id',
        name: 'not-planned-pickup',
        component: () => import('../views/pickups/viewNotPlannedPickup'),
        meta: {
          auth: true,
          permission: 'pickup/not-planned',
        },
      },
    ],
  },
  // Settings
  {
    path: '/settings/platform',
    component: () => import('../views/settings/platform'),
    children: [
      {
        path: 'printers',
        name: 'printers',
        component: () => import('../views/settings/printers'),
        meta: {
          title: 'Printers',
          auth: true,
          permission: 'settings/printer',
          breadCrumb: [
            {
              text: 'Printers',
              link: '',
            },
          ],
        },
      },
      {
        path: 'team',
        name: 'team',
        component: () => import('../views/settings/team'),
        meta: {
          title: 'Team',
          auth: true,
          permission: 'settings/team',
          breadCrumb: [
            {
              text: 'Team',
              link: '',
            },
          ],
        },
      },
      {
        path: 'smtp',
        name: 'smtp',
        component: () => import('../views/settings/smtp'),
        meta: {
          title: 'SMTP',
          auth: true,
          permission: 'settings/smtp',
          breadCrumb: [
            {
              text: 'Smtp',
              link: '',
            },
          ],
        },
      },
      {
        path: 'system',
        name: 'system',
        component: () => import('../views/settings/system'),
        meta: {
          title: 'system',
          auth: true,
          permission: 'settings/system',
          breadCrumb: [
            {
              text: 'System',
              link: '',
            },
          ],
        },
      },
    ],
  },
  {
    path: '/settings/shipping',
    component: () => import('../views/settings/shipping'),
    children: [
      {
        path: 'payers',
        name: 'payers',
        component: () => import('../views/settings/payers'),
        meta: {
          title: 'Payers',
          auth: true,
          permission: 'settings/payer',
          breadCrumb: [
            {
              text: 'Payers',
              link: '',
            },
          ],
        },
      },
      {
        path: 'locations',
        name: 'locations',
        component: () => import('../views/settings/locations'),
        meta: {
          title: 'Locations',
          auth: true,
          permission: 'settings/sender',
          breadCrumb: [
            {
              text: 'Locations',
              link: '',
            },
          ],
        },
      },
      {
        path: 'packaging',
        name: 'packaging',
        component: () => import('../views/settings/packages'),
        meta: {
          title: 'packaging',
          auth: true,
          permission: 'settings/package',
          breadCrumb: [
            {
              text: 'Packages',
              link: '',
            },
          ],
        },
      },
      {
        path: 'agreements',
        name: 'agreements',
        component: () => import('../views/settings/agreements'),
        meta: {
          title: 'Agreements',
          auth: true,
          permission: 'settings/account',
          breadCrumb: [
            {
              text: 'Carrier accounts',
              link: '',
            },
          ],
        },
      },
      {
        path: 'agreements/:id',
        name: 'agreement',
        component: () => import('../views/settings/agreementsView'),
        meta: {
          title: 'Agreements',
          auth: true,
          permission: 'settings/account',
          breadCrumb: [
            {
              text: 'Carrier account',
              link: '',
            },
          ],
        },
      },
      {
        path: 'customize-notification/:id',
        name: 'customize-notification',
        component: () => import('../views/settings/customizeNotification'),
        meta: {
          title: 'Notifications',
          auth: true,
          permission: 'settings/message',
        },
      },
      {
        path: 'notifications',
        name: 'notifications',
        component: () => import('../views/settings/notifications'),
        meta: {
          title: 'Notifications',
          auth: true,
          permission: 'settings/message',
        },
      },
    ],
  },
  {
    path: '/settings/integration',
    component: () => import('../views/settings/integration.vue'),
    children: [
      //Ftp
      {
        path: 'ftp',
        name: 'ftp',
        component: () => import('../views/settings/ftp'),
        meta: {
          title: 'Ftp',
          auth: true,
          permission: 'settings/ftp',
          breadCrumb: [
            {
              text: 'Ftp',
              link: '',
            },
          ],
        },
      },
      {
        path: '/settings/integration/add-ftp-template',
        name: 'add-ftp-template',
        component: () => import('../views/settings/addFtpTemplate'),
        meta: {
          title: 'add_ftp_template',
          auth: true,
          permission: 'settings/ftp',
        },
      },
      {
        path: '/settings/integration/edit-ftp-template/:id',
        name: 'edit-ftp-template',
        component: () => import('../views/settings/editFtpTemplate'),
        meta: {
          title: 'edit_ftp_template',
          auth: true,
          permission: 'settings/ftp',
        },
      },
      //Automations
      {
        path: 'automations/:id',
        name: 'automation',
        component: () => import('../views/settings/automationsView'),
        meta: {
          auth: true,
          permission: 'settings/automations',
        },
      },
      {
        path: 'automations',
        name: 'automations',
        component: () => import('../views/settings/automations'),
        meta: {
          auth: true,
          permission: 'settings/automations',
        },
      },
      //Webhooks
      {
        path: 'webhooks/:id',
        name: 'webhook',
        component: () => import('../views/settings/webhooksView'),
        meta: {
          title: 'webhook',
          auth: true,
          permission: 'settings/webhook',
        },
      },
      {
        path: 'webhooks',
        name: 'webhooks',
        component: () => import('../views/settings/webhooks'),
        meta: {
          title: 'webhooks',
          auth: true,
          permission: 'settings/webhook',
        },
      },
      //Import templates
      {
        path: 'import-templates',
        name: 'import-templates',
        component: () => import('../views/settings/importTemplates'),
        meta: {
          title: 'Import templates',
          auth: true,
          permission: 'settings/import-template'
        },
      },
      {
        path: '/settings/add-template',
        name: 'add-template',
        component: () => import('../views/settings/addTemplate'),
        meta: {
          title: 'add_upload_template',
          auth: true,
          permission: 'settings/import-template',
        },
      },
      {
        path: '/settings/edit-template/:id',
        name: 'edit-template',
        component: () => import('../views/settings/editTemplate'),
        meta: {
          title: 'edit_upload_template',
          auth: true,
          permission: 'settings/import-template',
        },
      },
      // Checkout Engine
      // {
      //   path: 'checkout-engine',
      //   name: 'checkout-engine',
      //   component: () => import('../views/settings/checkoutEngine'),
      //   meta: {
      //     title: 'checkout_engine',
      //     auth: true,
      //     permission: 'settings/import-template',
      //   },
      // },
      // {
      //   path: 'checkout-engine/add',
      //   name: 'checkout-engine-add',
      //   component: () => import('../views/settings/editCheckoutEngineMapping'),
      //   meta: {
      //     title: 'add_mapping',
      //     auth: true,
      //     permission: 'settings/import-template',
      //   },
      // },
      // {
      //   path: 'checkout-engine/:id',
      //   name: 'checkout-engine-edit',
      //   component: () => import('../views/settings/editCheckoutEngineMapping'),
      //   meta: {
      //     title: 'edit_mapping',
      //     auth: true,
      //     permission: 'settings/import-template',
      //   },
      // },
    ]
  },
  // Connect
  {
    path: '/connect',
    component: () => import('../views/connect'),
    children: [
      {
        path: 'shops',
        name: 'shops',
        component: () => import('../views/connect/shops'),
        meta: {
          auth: true,
          breadCrumb: [
            {
              text: 'Shops',
              link: '',
            },
          ],
        },
      },
      {
        path: 'shipping-methods',
        name: 'shipping-methods',
        component: () => import('../views/connect/shippingMethods'),
        meta: {
          auth: true,
          breadCrumb: [
            {
              text: 'Shipping methods',
              link: '',
            },
          ],
        },
      },
    ],
  },
  // User
  {
    path: '/user',
    component: () => import('../views/user'),
    children: [
      {
        path: 'wall/:id',
        name: 'user-wall',
        component: () => import('../views/user/wall'),
        meta: {
          title: 'Wall',
          auth: true,
          permission: true,
        },
      },
      {
        path: 'permissions/:id',
        name: 'user-permissions',
        component: () => import('../views/user/permissions'),
        meta: {
          title: 'permissions',
          auth: true,
          permission: true,
        },
      },
      {
        path: 'preferences/:id',
        name: 'user-preferences',
        component: () => import('../views/user/preferences'),
        meta: {
          title: 'Preferences',
          auth: true,
          permission: true,
        },
      },
    ],
  },
  {
    path: '/profile',
    component: () => import('../views/user'),
    children: [
      {
        path: 'wall',
        name: 'profile-wall',
        component: () => import('../views/user/wall'),
        meta: {
          title: 'Wall',
          auth: true,
          permission: true,
        },
      },
      {
        path: 'permissions',
        name: 'profile-permissions',
        component: () => import('../views/user/permissions'),
        meta: {
          title: 'permissions',
          auth: true,
          permission: true,
          requiresAdmin: true,
        },
      },
      {
        path: 'preferences',
        name: 'profile-preferences',
        component: () => import('../views/user/preferences'),
        meta: {
          title: 'Preferences',
          auth: true,
          permission: true,
        },
      },
    ],
  },
// Reports
  {
    path: '/reports',
    name: 'reports',
    component: () => import('../views/reports/reports'),
    meta: {
      title: 'Reports',
      auth: true,
      permission: true,
      breadCrumb: [
        {
          text: 'Reports',
          link: '',
        },
      ],
    },
  },
];

const hasAccess = (routeTO, callback) => {
  let pathTerm = store.state.settings.userPermissions.filter((permission) => permission.acl_route_group == routeTO.meta.permission)[0];
  if(store.state.settings.userPermissions.length !== 0){
    if(routeTO.name == 'dashboard' && !pathTerm.view){
      return callback('/profile/wall');
    }
    if(typeof pathTerm !== 'undefined'){
      if(pathTerm.view){
        return callback();
      } else {
        return false;
      }
    } else if (routeTO.meta.permission == true) {
      return callback();
    } else {
      // Zabrani
      return false;
    }
  } else {
    setTimeout(() => {
      hasAccess(routeTO, callback);
    }, 1000)
  }

  // return callback();
}

let isUserLoggedIn = () => store.state.user.token !== '';

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
});

//In each case 'next' function should be executed only once
router.beforeEach(async (to, from, next) => {
  const forceRedirect = store.state.forceRedirect
  if (forceRedirect) {
    store.commit('SET_FORCE_REDIRECT', null)
    return next(forceRedirect)
  }

  // Bootstrap auth once per app load — awaits the same promise for concurrent navigations
  if (!store.state.user.bootstrapComplete) {
    if (!bootstrapPromise) {
      bootstrapPromise = store.dispatch('BOOTSTRAP_AUTH')
    }
    await bootstrapPromise
  }

  const isLoggedIn   = isUserLoggedIn()
  const isAuthNeeded = to.meta.auth
  let decodedToken = null
  if (isLoggedIn) {
    decodedToken = jwt(store.state.user.token);
  }

  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start()
  }

  const matchedComponents = from.matched
  if (matchedComponents) {
    const currentComponent = matchedComponents[0]?.components?.default
    if (currentComponent && currentComponent?.options?.beforeRouteLeave) {
      // The component will handle the navigation guard
      next()
      return
    }
  }

  if (to.path === '/signin') {
    //Case when we signin user directly from backoffice
    store.commit('LOGOUT')
    if (to.query.code) {
      // exchange-code: server also sets httpOnly refresh cookie in this response
      axios.post('authenticate/exchange-code', { code: to.query.code }, { withCredentials: true })
        .then(async res => {
          try {
            const token = res.data.data.token
            store.dispatch('STORE_TOKEN', token)
            const profile = await store.dispatch('GET_PROFILE')
            store.dispatch('STORE_USER', profile)
            await store.dispatch('GET_MY_PERMISSIONS')
            const subaccounts = await store.dispatch('GET_SUBACCOUNTS')
            const active = profile.active_subaccount_id != null
              ? subaccounts.filter(s => s.id == profile.active_subaccount_id)[0]
              : subaccounts.filter(s => s.is_main == 1)[0]
            store.dispatch('STORE_ACTIVE_SUBACCOUNT', active)
            localStorage.setItem('subaccount', JSON.stringify(active))
            localStorage.userId = profile.id
            store.dispatch('LOGIN_USER_FLAG', true)
            // Re-anchor bootstrap state before navigating: if bootstrapPromise was
            // reset to null by HMR (module re-evaluation), a null check in the guard
            // would dispatch BOOTSTRAP_AUTH a second time even though state is fully
            // restored here. Committing SET_BOOTSTRAP_COMPLETE and pre-filling
            // bootstrapPromise with a resolved Promise prevents that second dispatch.
            store.commit('SET_BOOTSTRAP_COMPLETE')
            bootstrapPromise = bootstrapPromise || Promise.resolve()
            next('/dashboard')
          } catch (e) {
            console.error('[ROUTER] /signin code exchange failed:', e?.message || e)
            next('/login')
          }
        })
        .catch((e) => {
          console.error('[ROUTER] /signin exchange-code request failed:', e?.message || e)
          next('/login')
        })
    } else if (to.query.token) {
      // backward compatibility: direct token in URL (old flow — no refresh cookie)
      store.dispatch('STORE_TOKEN', to.query.token)
      next('/dashboard')
    } else {
      next('/login')
    }
  } else if (to.path === '/login') {
    //Whenever user click/type login route we should automatically logout current user and let him login again
    store.commit('LOGOUT')
    next();
  } else if (to.path === '/logout') {
    //Case when we click logout button from app
    store.dispatch('LOGOUT').finally(() => next('/login'));
  } else if (isLoggedIn && decodedToken && !decodedToken.backoffice_id) {
    //Case when we have old token without backoffice id
    store.commit('LOGOUT')
    next('/login');
  } else if (isLoggedIn && ['consolidations'].includes(to.name) && decodedToken && ![1, 3].includes(parseInt(decodedToken.backoffice_id))) {
    //Case when only backoffice 1 and 3 can access route, prevent any other
    next('/dashboard');
  } else if (isLoggedIn && ['agreements', 'invoices'].includes(to.name) && decodedToken && parseInt(decodedToken.backoffice_id) !== 1) {
    //Case when only backoffice 1 (SHIP365) can access route, prevent any other
    next('/dashboard');
  } else if (!isAuthNeeded && isLoggedIn) {
    //Case when we go to eg. /login route directly from url, but user is logged in
    next('/dashboard');
  } else if (isAuthNeeded && isLoggedIn) {
    //Case when auth is necessary and user is logged in, eg. from /contacts to /locations
    if (to.meta.requiresAdmin && !store.getters.get_user?.is_admin) {
      return next({ name: 'profile-preferences' });
    }
    hasAccess(to, next);
  } else if (isAuthNeeded && !isLoggedIn) {
    //Case when we wanna go to /contacts for eg, but user is not logged in
    const loginpath = window.location.pathname;
    next({ name: 'login', query: { from: loginpath } });
  } else {
    next();
  }
})

router.afterEach((to) => {
  if (to.meta.auth) updateLastActivity()
  store.dispatch('GET_ADMIN_SETTINGS', window.location.hostname).finally(() => {
    const DEFAULT_TITLE = store.getters?.get_admin_settings?.name || store.getters?.get_user?.backoffice_name || "SHIP365"
    if(to.meta.hasOwnProperty('title')){
      document.title = DEFAULT_TITLE + '  |  ' + i18n.t(to.meta.title);
    } else {
      document.title = DEFAULT_TITLE;
    }

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    if (store.getters?.get_admin_settings?.admin_dashboard_settings) {
      const dashboardSettings  = store.getters?.get_admin_settings?.admin_dashboard_settings;
      link.href = process.env.BASE_URL + (dashboardSettings.favicon || 'favicon.ico');
    }
  });
  NProgress.done()
});

export default router;
